module.exports = __webpack_public_path__ + "img/team-insights-custom-reports-unscheduled.9922f566.png";